import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Select, Space } from "antd";
const { Search } = Input;
const options = [
  {
    value: "Germplasm",
    label: "Germplasm",
  },
  {
    value: "Gene",
    label: "Gene",
  },
];
function HeaderSearchComponent() {
  const [SelectVal, setSelectVal] = useState("Germplasm" || "");
  const [searchText, setSearchText] = React.useState("");
  const SelectFn = (e) => {
    setSelectVal(e);
  };
  const onSearch = (value) => {
    console.log(SelectVal);
    console.log(value);
  };
  return (
    <div
      style={{
        height: "50%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop:"10px"
        
      }}
    >
      <div style={{ display: "flex", height: "15%" }}>
        <Select
          style={{ width: 200,margin:"0 5px" }}
          defaultValue="Germplasm"
          options={options}
          onChange={SelectFn}
        />
        <Search onSearch={onSearch} defaultValue="Xihu District, Hangzhou" />
      </div>
      <p style={{ width: "100%", fontSize: "17px", paddingLeft: "40%",color:"white",paddingTop:"5px"}}>
        Example:{SelectVal == "Germplasm" ? "Germplasm" : "Gene"}
      </p>
    </div>
  );
}

export default HeaderSearchComponent;
